module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABXElEQVQ4T72UMUsDQRSEZ7ggqIgQbGIh+hfE3kL7NIJNUt29SyHY+hcs7GyyuwfGsxAEm1QiFv4Exc7aShASm8Qou3JFJIm54w5Cttyd9zFvd94SM16cMQ/zBQZBcESyRnLTOfdC8kxrfZ/VVapDEYlI+pPF1tpGFEU6DToVKCK7JB9TinqDwWC91Wp1pp2nAU9JnqS5cM5VjTHtWQIPjDG3uYG+7+95nveQ4vC73+9X4jj+yA1MhGEYXgGoTRaRPFZKnRd6lKFYRITkIYAKgFeSSil1Vzg2vu+XS6VS3Vq7DcCSXAHQBbBE8onkRbPZfM/Vsojsk7wGsJbhpOOcaxhjbv5dyehGEARbJJOJWM4x4z8kd5RSz6PasRyGYRgDqOeADSVtrXU1C5hEoVwA+Km1Xk0FisgXyYUCQKu19rKASUzEObdBcjFj9HoA3gBcGmPGMjnf/7BA63/SX+CpdBVuRBtGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sh_login_icon_user.png
// module id = +kPD
// module chunks = 1